import React from 'react';
import { Text, View, Pressable, StyleSheet, Image } from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';
import { addCase, updateCase, leaveCase, resetStatusState, resetState } from './actions';

import {
  getEditingCaseWithFiles,
  getEditingCasePatient,
  getFileUploadStatusForEditingCase,
} from './selector';

import {
  OPComponent,
  Container,
  NavBar,
  I18n,
  Avatar,
  EditAvatar,
  Navigation,
  Utils,
  Alert,
} from '../components';

import { uploadFilesAndSaveToServer } from '../components/actions';

import { CASE_AVATAR } from '../../constants/objectTypes';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import CaseFields from './case_fields_consumer';

class CaseForm extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      profileImage: null,
    };

    this._isUpdate = !!props.editingCase;
    this._isCreate = !this._isUpdate;
    this._uploadingFile = false;
    this._caseFormRef = React.createRef();
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (this.props.status === REQUESTING || this.props.uploadStatus === REQUESTING) return;

    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Navigation.registerForButtonEvents(this);
    Utils.trackScreen('Cases', 'Case Form');

    Navigation.setButtons(
      {
        leftButtons: [NavBar.buttons.cancel],
        rightButtons: [NavBar.buttons.save],
      },
      this.props.componentId
    );
    this.props.actions.resetStatusState();
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    // if we got here via case info screen (isUpdate is true)
    // then dont clear the screen state except for request status.
    // cases screen complete state will be cleared when we exit case info
    // if its a new case then we didn't get here via case info so
    // we need to clear all of the cases screen state
    if (this._isUpdate) {
      this.props.actions.resetStatusState();
    } else {
      this.props.actions.resetState();
    }
    this.props.onCloseScreen && this.props.onCloseScreen(this._isUpdate);
  }

  componentDidUpdate(prevProps, prevState) {
    // uploaded photo
    if (this.props.uploadStatus === SUCCESS && prevProps.uploadStatus !== SUCCESS) {
      this.afterCaseAndAvatarSave();
      return;
    }
    if (this.props.status === FAILED || this.props.uploadStatus === FAILED) {
      this._uploadingFile = false;
    }
  }

  // called when Save navbar button is tapped
  onSave = () => {
    this.submit();
  };

  errorMessageFromProps() {
    return this.props.errorMessage?.message || this.props.uploadErrorMessage;
  }

  uploadAvatarFile() {
    if (this._uploadingFile || !this.state.profileImage || !this.props.editingCaseId) return;

    this._uploadingFile = true;

    this.props.actions.uploadFilesAndSaveToServer(
      CASE_AVATAR,
      this.props.editingCaseId,
      [this.state.profileImage],
      true
    );
  }
  afterCaseAndAvatarSave = () => {
    const props = this.props;

    if (this._isCreate) {
      this.goToInvite();
    } else {
      this.setState({ successMessage: 'Saved!' });
      Navigation.setButtons(
        {
          leftButtons: [NavBar.buttons.done],
          rightButtons: [NavBar.buttons.save],
        },
        this.props.componentId
      );
    }
  };

  handleCaseSave = () => {
    if (this.state.profileImage) {
      this.uploadAvatarFile();
    } else {
      this.afterCaseAndAvatarSave();
    }
  };

  submit = () => {
    Utils.trackEvent('Action', 'Tap', 'Submit Case');

    const formIsValid = this._caseFormRef.current?.submit();

    if (!formIsValid) {
      this.setState({ errorMessage: I18n.t('form.pleaseResolveErrors') });
      return;
    }
  };

  goToInvite = () => {
    // const inviteResidents = true;
    // launch invite screen
    Navigation.push(
      {
        screen: 'Invite',
        title: I18n.ac('invite.invitePeople'),
        passProps: {
          editingCase: true,
          noBacksies: true,
          initialSuccessMessage: I18n.t('case.personalAddSuccess'),
        },
      },
      this.props.componentId
    );
  };

  unfollow = () => {
    Alert.alert(I18n.ce('case.unfollowCase'), I18n.t('case.unfollowCaseConfirmMessage'), [
      {
        text: I18n.c1('no'),
      },
      {
        text: I18n.c1('yes'),
        onPress: () => this.props.actions.leaveCase(this.props.editingCaseId),
      },
    ]);
  };

  handleImageSelected = (profileImage) => {
    Utils.trackEvent('Action', 'Tap', 'Image Added to Message');

    this.setState({ profileImage });
  };

  renderAvatarHeader() {
    const props = this.props;

    const avatarAttachment = props.editingCase?.avatar;
    return (
      <View style={styles.header}>
        <EditAvatar onSelectImage={this.handleImageSelected}>
          <Avatar
            initialsStr={props.editingCase?.name}
            onPress={null}
            avatarUrl={this.state.profileImage ? this.state.profileImage.image.uri : null}
            attachment={avatarAttachment}
          />
        </EditAvatar>
      </View>
    );
  }

  render() {
    const { currentEmployer } = this.props;
    const props = this.props;
    const isUpdate = this._isUpdate;

    return (
      <Container
        keyboardAvoidingScrollView={true}
        renderActivityOverlay={
          this.props.status === REQUESTING || this.props.uploadStatus === REQUESTING
        }
        successMessage={this.state.successMessage}
        errorMessage={this.state.errorMessage || this.errorMessageFromProps()}
      >
        {this.renderAvatarHeader()}

        <CaseFields
          ref={this._caseFormRef}
          editingCase={this.props.editingCase}
          editingCasePatient={this.props.editingCasePatient}
          componentId={this.props.componentId}
          updateCase={this.props.actions.updateCase}
          addCase={this.props.actions.addCase}
          status={this.props.status}
          onSave={this.handleCaseSave}
        />

        {!!isUpdate && (
          <Pressable style={styles.footerButton} onPress={this.unfollow}>
            <Image
              style={styles.footerIcon}
              source={require('../../../resources/icon-logout.png')}
              resizeMode="contain"
            />
            <Text style={styles.footerButtonText}>{I18n.ac('case.unfollowCase')}</Text>
          </Pressable>
        )}
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    paddingHorizontal: 25,
    paddingTop: 20,
    backgroundColor: COLOR.contrast,
    alignItems: 'center',
  },
  inputsContainer: THEME.inputsContainer,
  footerButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 25,
    paddingVertical: 20,
  },
  footerIcon: {
    tintColor: COLOR.emphasis,
    width: 13,
    height: 15,
    marginRight: 20,
  },
  footerButtonText: {
    ...FONT.semibold,
    fontSize: FONT_SIZE.small,
    color: COLOR.emphasis,
  },
  caseNameText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.xlarge,
    color: COLOR.textLight,
    marginLeft: 15,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.cases.status,
    errorMessage: state.screens.cases.errorMessage,
    editingCase: getEditingCaseWithFiles(state),
    editingCasePatient: getEditingCasePatient(state),
    editingCaseId: state.screens.cases.caseInfoCaseId,
    uploadStatus: getFileUploadStatusForEditingCase(state).status,
    uploadErrorMessage: getFileUploadStatusForEditingCase(state).errorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        addCase,
        updateCase,
        leaveCase,
        resetStatusState,
        resetState,
        uploadFilesAndSaveToServer,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseForm);
